import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=277f6bfe&"
import script from "./artist.vue?vue&type=script&lang=js&"
export * from "./artist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports